module.exports = __webpack_public_path__ + "static/media/yes-we-are-open-news.9786d011.jpg";